import { DOCS_URL } from "../../../config/constants.js";
import ServiceQuoteCard from "./ServiceQuoteCard.svelte";

export default {
    component: ServiceQuoteCard,
    name: "Service Quote Card",
    description: "Compact quote card for service pages",
    docsLink: `${DOCS_URL}/storybook/?path=/story/molecules-servicequotecard--default`,
    image: "https://unpkg.com/@tabler/icons@3.5.0/icons/outline/quote.svg",
    models: ["service-page"],
    hideFromInsertMenu: true,
    requiresParent: {
        message: "Service Quote Card must be used inside a Service Callout Container.",
        component: "Service Callout Container",
    },
    inputs: [
        { friendlyName: "Quote", name: "quote", type: "longText", required: true },
        { friendlyName: "Person", name: "person", type: "string" },
        { friendlyName: "Company", name: "company", type: "string" },
        {
            friendlyName: "Image",
            name: "image",
            type: "object",
            subFields: [
                {
                    friendlyName: "Source",
                    name: "src",
                    type: "file",
                    allowedFileTypes: ["jpg", "jpeg", "png", "webp", "svg"],
                },
                { friendlyName: "Alt", name: "alt", type: "text" },
            ],
        },
    ],
};
